import { Link } from '@tanstack/router'
import axios from 'axios'
import { useEffect, useState } from 'react'

import shadow from '../../assets/profile/freespin_shadow.webp'
import useDimensions from '../../hooks/useDimensions'
import useTranslateImage from '../../hooks/useTranslateImage'
import { useBoundStore } from '../../store/store'
import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'

type FreeSpins = {
  closeProfileDrawer?: () => void
}

const FreeSpins = ({ closeProfileDrawer }: FreeSpins) => {
  const username = useBoundStore(state => state.user.username)
  const translateImage = useTranslateImage()
  const { isDesktop } = useDimensions()
  const [numberOfSpins, setNumberOfSpins] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!username) return
    const controller = new AbortController()
    const signal = controller.signal

    const fetchSpins = async () => {
      try {
        const response = await api.post<
          ApiResponse<{
            total_amount: number
          }>
        >('/request.php', { type: 'free_spin_amount' }, { signal })
        const { status, info } = response.data
        if (status === 1) {
          setNumberOfSpins(info.total_amount)
        } else {
          setNumberOfSpins(0)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error)
        }
        setNumberOfSpins(0)
      } finally {
        setIsLoading(false)
      }
    }
    fetchSpins()

    return () => {
      controller.abort()
    }
  }, [username])

  if (isLoading || !username) return null

  return (
    <Link to="/profile/free-spins">
      <span
        className="absolute z-[5] w-[110px] h-[75px] right-[-5px] top-2 xl:right-0 xl:top-5"
        onClick={
          !isDesktop && closeProfileDrawer
            ? () => closeProfileDrawer()
            : undefined
        }>
        <img
          className="w-[70px] absolute z-[1] left-5 top-0"
          src={translateImage('freespins')}
          alt="Free Spins"
        />
        <img
          className="absolute w-[110px] -top-1 -right-[2px]"
          src={shadow}
          alt="Shadow"
        />
        <p className="absolute w-full text-center text-[11px] font-Avenir-Black text-shadow-white-sm text-[#fff4e1] z-[2] left-0 bottom-[15px]">
          {numberOfSpins}
        </p>
      </span>
    </Link>
  )
}

export default FreeSpins
